import { Modal } from "@mui/material";
import React, { useState } from "react";

import classes from "./AddModal.module.css";

const AddModal = ({ openModal, onClose, addFunc }) => {
  const handleSubmit = () => {};

  const [name, setName] = useState();
  const [lastName, setLastName] = useState();
  const [workPlace, setWorkPlace] = useState();

  return (
    <Modal style={{ width: "100%" }} open={openModal} onClose={onClose}>
      <div className={classes["modal"]}>
        <form onSubmit={handleSubmit}>
          <div className={classes["input-wrapper"]}>
            <h2 className={classes["title"]}>Add teacher</h2>
            <input
              placeholder="Firstname"
              className={classes["input"]}
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
            <input
              placeholder="LastName"
              className={classes["input"]}
              type="text"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              required
            />{" "}
            <input
              placeholder="Workplace"
              className={classes["input"]}
              type="text"
              value={workPlace}
              onChange={(e) => setWorkPlace(e.target.value)}
              required
            />
            <div className={classes["button-wrapper"]}>
              <button
                type="submit"
                onClick={onClose}
                style={{ background: "red" }}
                className={classes["send-button"]}
              >
                {"Cancel"}
              </button>
              <button type="submit" className={classes["send-button"]}>
                {"Add"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default AddModal;
